window.okeReviewsWidgetOnInit = function (okeInitApi) {
    window.loadOkendo = function () {
        okeInitApi.initCoreWidgets().then(() => setupReviews());
    };

    setupReviews();
};

function setupReviews() {
    setUpHeader();
    translateReviewInStar();

    const reviewMain = document.querySelector(".js-okeReviews-reviews-main");

    if (reviewMain) {
        const observerConfig = {
            childList: true,
        };

        const callback = function (mutationList, observer) {
            hideShippingRating();
            moveReviewComponents();
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, observerConfig);
        hideShippingRating();
        moveReviewComponents();
    }
}

function translateReviewInStar() {
    var html = document.documentElement,
        lang = html.getAttribute("lang");

    if (lang != "fr") return;

    var okendoReviewStars = document.querySelectorAll(".okeReviews-reviewsSummary-ratingCount");
    if (okendoReviewStars) {
        okendoReviewStars.forEach((starRating) => {
            var reviewText = starRating.innerHTML;
            if (reviewText) {
                starRating.innerHTML = reviewText.replace(" Review", " avis").replace("aviss", "avis");
            }
            starRating.style.display = "inline-block";
        });
    }
}

// Move reviews aggegrate and review button into control
function setUpHeader() {
    var writeReviewButton = document.querySelector(".js-okeReviews-writeReview");
    var reviewsControlsHeader = document.querySelector(".okeReviews-reviews-controls");

    if (
        reviewsControlsHeader &&
        writeReviewButton &&
        !writeReviewButton.className.includes("is-okeReviews-hiddenButton")
    ) {
        reviewsControlsHeader.prepend(writeReviewButton);
    }
}

// Get all rating bars and show all none shipping attributes by attaching a class to it
const hideShippingRating = function () {
    var ratingBars = document.querySelectorAll(".okeReviews-attributeRatingsTable-row");

    if (ratingBars) {
        ratingBars.forEach((bar) => {
            var label = bar.querySelector(".okeReviews-attributeRatingsTable-row-label");

            if (label && label.innerText.trim() != "Shipping") {
                bar.classList.add("okeReviews-non-shipping-attributes");
            }
        });
    }
};

function moveReviewComponents() {
    document.querySelectorAll(".okeReviews-reviews-review").forEach((review) => {
        var reviewRecommendation = review.querySelector(".okeReviews-review-recommendation");
        var reviewPrimary = review.querySelector(".okeReviews-review-main-content");

        if (reviewPrimary && reviewRecommendation) {
            reviewPrimary.appendChild(reviewRecommendation);
        }
    });
}
